import { SectionService } from "@airnauts/ng-components/section";
import { TableColumn } from "@airnauts/ng-components/table/table.component";
import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { Component, EventEmitter, Input, OnInit, Optional, Output, ViewChild, ViewEncapsulation } from "@angular/core";
import { merge } from "rxjs";
import { map } from "rxjs/operators";
import { CustomSectionService } from "../custom-section/custom-section.service";
import { StackPaginatorComponent } from "../stack-paginator/stack-paginator.component";
import { CustomDataSource, DataSourceQuery } from "./custom-table-data-source";

@Component({
  selector: 'cosmos-custom-table',
  templateUrl: './custom-table.component.html',
  styleUrls: ['./custom-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomTableComponent<T> implements OnInit {
  @Input() public columns: TableColumn<T>[];
  @Input() public dataSourceQuery: DataSourceQuery<T>;

  @ViewChild(StackPaginatorComponent, { static: true }) private _paginator: StackPaginatorComponent;

  @Output() public rowClicked = new EventEmitter<T>();

  public _searchable = false;
  public _dataSource: CustomDataSource<T>;

  public get searchable(): any {
    return this._searchable;
  }

  @Input()
  public set searchable(value: any) {
    this._searchable = coerceBooleanProperty(value);
  }

  public get selectable() {
    return this.rowClicked.observers.length !== 0;
  }

  public constructor(
    @Optional() private readonly _sectionService: SectionService,
    @Optional() private readonly _customSectionService: CustomSectionService,
  ) {}

  public ngOnInit(): void {
    this._dataSource = new CustomDataSource<T>(this.dataSourceQuery, this._paginator);

    merge(this._paginator.nextEvent, this._paginator.backEvent)
      .pipe(map(() => this._paginator.value))
      .subscribe((x) => this._dataSource.setCursorPaginator(x));

    this._dataSource.customLoading$.subscribe((x) => {
      this._sectionService?.setLoading(x);
      this._customSectionService?.setLoading(x);
    });
  }
}
